import { type ReactElement } from 'react';
import { type CustomResponseProps } from '../../chat-responses/types.js';

type Props = CustomResponseProps<'dm-hcp-alerts'>;

export function DMHCPAlerts(_: Props): ReactElement {
  return <div />;
}
